// abortControllerManager.js
const abortControllers = new Map();

export const getAbortController = (key) => {
  if (!abortControllers.has(key)) {
    abortControllers.set(key, new AbortController());
  }
  return abortControllers.get(key);
};

export const removeAbortController = (key) => {
  abortControllers.delete(key);
};
